// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;

const html = String.raw

const buildProductUrlWithNoCollection = (data) => {
	return `/products/${data.handle}`
}

// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: 48,
		loadProductFirst: true,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style2'
	}
};

function setAttributes(el, attrs) {
	for(var key in attrs) {
	  el.setAttribute(key, attrs[key]);
	}
  }

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (isVariantAvailable(data['variants'][i])) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	let count = 0;
	ProductGridItem.prototype.compileTemplate = function (data) {
		count++;
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';

		if(window.marketing_blocks?.length > 0){
			var marketing_block = window.marketing_blocks.filter((x) => {return x.id === count}); 
			if(marketing_block !== undefined && marketing_block.length){
				marketing_block.forEach((block) => {
					itemHtml = buildMarketingBlock(block.content) + itemHtml;
				});
			}
		}

		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add Images
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
		// Add Price
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
		// Add Badges 
		itemHtml = itemHtml.replace(/{{itemBadges}}/g, buildBadges(data));
		// Add Description
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, buildDescription(data));
		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));
		
		// Add Color Swatches
		itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildProductOptionSwatches(data));

		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
					itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildProductReviews(data));
				}

		itemHtml = itemHtml.replace(/{{itemButton}}/g, buildButton(data));

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, buildProductUrlWithNoCollection(data));
		itemHtml = itemHtml.replace(/{{itemCalloutMessage}}/g, buildPromoCallout(data))
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/


	function buildMarketingBlock(data) {
		var html = '',
			content_color = '',
			html_cta = '';
		if(data.content_color !== '' && data.content_color !== undefined){
			if (data.content_color == 'Light'){
				content_color = 'color: #fff;';
			}else{
				content_color = 'color: #000;';
			}
		}
		if(data.cta_copy !== '' && data.cta_copy !== undefined && data.cta_url !== '' && data.cta_url !== undefined){
		  html_cta += '<a href="'+data.cta_url+'" class="cta" style="'+content_color+'">';
			html_cta += '<span>'+data.cta_copy+'</span>';
		  html_cta += '</a>';
		}
		if(data.block_layout  === "1 Columns"){

			const imageWrapClass = !data.content_title && !data.content_copy && !html_cta 
				? 'image-wrap image-wrap__no-content'
				: 'image-wrap';

		  html += '<div class="card-wrapper marketing_single_card">';           
			html += `<div class="card-content animate fade"><div class="${imageWrapClass}">`;
			  if(data.image !== '' && data.image !== undefined){
				html += '<a href="'+data.cta_url+'" class="cta" style="'+content_color+'">';
				html += '<img src="'+data.image+'" alt=""/>';
				html += '</a>';
			  }
			  if(data.content_title !== '' && data.content_title !== undefined){
				html += '<a href="'+data.cta_url+'" class="cta" style="'+content_color+'">';
				html += '<h6 style="'+content_color+'" class="card-content__headline">'+data.content_title+'</h6>';
				html += '</a>';
			  }
			  html += '</div>';
			  html += '<div class="card-content-bottom">';
				if(data.content_copy !== '' && data.content_copy !== undefined){
				  html += '<p style="'+content_color+'">'+data.content_copy+'</p>';
				}
				html += html_cta;
				html += '</div>';
			html += '</div>';
		  html += '</div>';
		}else{
			html += '<div class="card-wrapper marketing_two_card">';           
			html += '<div class="card-content animate fade">';
			  if(data.image !== '' && data.image !== undefined){
				html += '<a href="'+data.cta_url+'" class="cta" style="'+content_color+'">';
				html += '<img src="'+data.image+'" alt=""/>';
				html += '</a>';
			  }
			  html += '<div class="card-content-bottom">';
				if(data.content_title !== '' && data.content_title !== undefined){
					html += '<a href="'+data.cta_url+'" class="cta cta__title" style="'+content_color+'">';
					html += '<h6 style="'+content_color+'" class="card-content__headline">'+data.content_title+'</h6>';
					html += '</a>';
				}
				if(data.content_copy !== '' && data.content_copy !== undefined){
				  html += '<p style="'+content_color+'">'+data.content_copy+'</p>';
				}
				html += html_cta;
				html += '</div>';
			html += '</div>';
		  html += '</div>';
		}
		return html;
	}

	// Build Product Reviews

	function buildProductReviews(data){
		let productReviewsHtml = '';
		let reviews = parseFloat(data.metafields.find(x => x.key === "reviews_average")?.value);
		if (!isNaN(reviews)){
			var empty = Math.floor(5 - reviews);
			var decimal = reviews - Math.floor(reviews);
			var full = reviews - decimal;
			for (let i = 1; i <= full; i++){
				productReviewsHtml += '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.08332 0L8.82463 4.13363L13.3444 4.49139L9.90082 7.40387L10.9529 11.7586L7.08332 9.425L3.21374 11.7586L4.26582 7.40387L0.822211 4.49139L5.34201 4.13363L7.08332 0Z" fill="black"></path></svg>';
			}
			if (decimal > 0){
				if (decimal >= 0.5){
					productReviewsHtml += '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25031 0L8.99162 4.13363L13.5114 4.49139L10.0678 7.40387L11.1199 11.7586L7.25031 9.425L3.38073 11.7586L4.43281 7.40387L0.989203 4.49139L5.509 4.13363L7.25031 0Z" fill="#CCCCCC"></path><path d="M7.24939 0L7.24944 4.13363V7.40388L7.24939 9.425L3.37981 11.7586L4.43189 7.40388L0.988281 4.49139L5.50808 4.13363L7.24939 0Z" fill="black"></path></svg>';
				}else{
					productReviewsHtml += '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.08332 0L8.82463 4.13363L13.3444 4.49139L9.90082 7.40387L10.9529 11.7586L7.08332 9.425L3.21374 11.7586L4.26582 7.40387L0.822211 4.49139L5.34201 4.13363L7.08332 0Z" fill="#CCCCCC"></path></svg>';
				}
			}
			for (let i = 1; i <= empty; i++){
				productReviewsHtml += '<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.08332 0L8.82463 4.13363L13.3444 4.49139L9.90082 7.40387L10.9529 11.7586L7.08332 9.425L3.21374 11.7586L4.26582 7.40387L0.822211 4.49139L5.34201 4.13363L7.08332 0Z" fill="#CCCCCC"></path></svg>';
			}
		}
		return productReviewsHtml;
	}

	// Build Color Swatches
	function buildProductOptionSwatches(data) {
			const soldOutVariantsString = data.metafields.find(metafield => metafield.key === 'sold_out_variants')?.value
			const soldOutVariants = soldOutVariantsString && JSON.parse(soldOutVariantsString)
			let swatchesProductOptionHtml = '';
			if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0 && data.options_with_values.length < 2) {      	        
              	var swatchArr = data.options_with_values[0];
				var swatchValues = swatchArr.values;
				let optionName = swatchArr.name;
                var productImages = data.original_images && data.original_images.length > 0 ? data.original_images : data.images_info;

				for (var sIndex = 0; sIndex < swatchArr.values.length; sIndex++) {
					var swatchName = swatchValues[sIndex].title;
					var swatchVariant = data['variants'][sIndex];
					let swatchColor = data.metafields.find(x => x.namespace === swatchVariant.id)?.value;
					let disabled = '';
					let priceFormated = Utils.formatMoney(data.variants[sIndex].price);
					let variantImage = data.variants[sIndex].image;
					if (!isVariantAvailable(swatchVariant, soldOutVariants)) {
						disabled = 'disabled';
					}
                    var valueColor = '';
                    var metaColor = data.metafields.find(meta => meta.id == data.variants[sIndex].id) || {};
                    metaColor.value !== 'undefined' ? valueColor = metaColor.value : valueColor = '';
                  
					let featured_media_founded = false;
					let founded_index;
					let alternative_image = '';
					let BreakException = {};
					try {
						productImages.forEach((image, index) => {
							if (data.variants[sIndex].image == image.src){
								founded_index = sIndex;
							}
							if (data.variants[sIndex].image == image.src || featured_media_founded){
								featured_media_founded = true;
								if (founded_index == sIndex){
									if (image.alt?.includes('~alternative')){
										alternative_image = image.src;
										throw BreakException
									}
									if ((images.length-1) == index){
										alternative_image = data.variants[sIndex].image;
									}
								}else{
									alternative_image = data.variants[sIndex].image;
								}
							}
						});
					} catch (e) {
						if (e !== BreakException) throw e;
					}	
					if(optionName == 'color' || optionName == 'colour' || optionName == 'shade'){
						swatchesProductOptionHtml += '<label data-variant-alternative-image="'+alternative_image+'" data-color-name="'+swatchName+'" data-variant-image="'+variantImage+'" data-variant-id="'+swatchVariant.id+'" style="background-color: '+valueColor+';" class="'+optionName+'_option '+disabled+'"></label>';
					} else {
						swatchesProductOptionHtml += '<label data-variant-alternative-image="'+alternative_image+'" data-variant-image="'+variantImage+'" data-variant-price="'+priceFormated+'" data-variant-id="'+swatchVariant.id+'" class="default_option '+disabled+'">'+swatchName+'</label>';
					}
				
				}
		
			}
		return swatchesProductOptionHtml;
	}
           
	function isVariantAvailable(variant, soldOutVariants) {
		if (soldOutVariants && soldOutVariants.includes(String(variant.id))) return false
		if (typeof variant.available !== 'undefined') return variant.available;
        if (variant.inventory_policy === "continue" || variant.inventory_management !== "shopify") return true;
           
        return variant.inventory_quantity > 0;
    }


	function buildButton(data) {
		let buttonHtml = '',
		buttonContainerClass = '',
		available_variants = 0,
		selected_or_first_available_variant_id = 0,
		data_variant = '',
		outofstock = '',
		buttonText = '';
		isLink = false;
		const isKit = data.product_type === 'Kit';

		// If it's a gift card just go to gift card page
		if (data.handle == 'rise-ai-giftcard' || data.handle == 'giftcard') {
			buttonText = 'Choose Amount';
			buttonHtml = `
				<div class="product-cart-button">
					<a href="/products/${data.handle}">
						<span class="button-text">${buttonText}</span>
						${buildPrice_card(data)}
					</a>
				</div>
			`;

			return buttonHtml;
		}

		//Sephora
		if (boostPFSThemeConfig.custom.sephora_linking && data.metafields.find(x => x.key === "sephora_linking")) {
			var buttonLink = data.metafields.find(x => x.key === "sephora_linking")?.value;
			buttonText = 'Available At Sephora';
			buttonHtml = `
				<div class="button-sephora-wrap">
					<a class="button-redirect button-redirect-light" href="${buttonLink}" target="_blank">
						<span class="button-text">${buttonText}</span>
						<span class="button-price">${buildPrice_card(data)}</span>
					</a>
				</div>
			`;

			return buttonHtml;
		}

		for (let i = 0; i < data['variants'].length; i++){
			if (isVariantAvailable(data['variants'][i])){
				if (selected_or_first_available_variant_id == 0){
					selected_or_first_available_variant = data['variants'][i].id;
				}
				available_variants++;
			}
		}
		if (typeof data.options_with_values != 'undefined' && data.options_with_values.length > 0 && data.options_with_values.length < 2 && available_variants > 1 && !data.tags.includes('force-sign-up')) {
			buttonContainerClass = 'js-open-selectors';
		}

		if (!data.available) {
      buttonText = 'Out of Stock';
      outofstock = 'outofstock';
    } else if (data.tags.includes('force-sign-up')) {
      buttonText = 'Sign Up Now';
      outofstock = 'outofstock';
			isLink = true
    } else if (data.tags.includes('force-oos')) {
			buttonText = 'Out of Stock';
      outofstock = 'outofstock';
		} else {
      if (isKit) {
        buttonText = window.TMW.strings.getTheLook.viewKit;
      } else {
        if (
          available_variants == 1 ||
          data['variants'].length < 2 ||
          typeof data.variant_id !== 'undefined'
        ) {
          buttonContainerClass = 'js-open-selectors';
          if (typeof data.variant_id !== 'undefined') {
            data_variant =
              'data-selected-variant="' +
              data.variant_id +
              '" data-drawer-trigger aria-controls="mini-cart" aria-expanded="false"';
          } else {
            data_variant =
              'data-selected-variant="' +
              selected_or_first_available_variant +
              '" data-drawer-trigger aria-controls="mini-cart" aria-expanded="false"';
          }
          buttonText = 'Add to Bag';
        } else if (data.options_with_values.length > 1) {
          buttonText = 'Select Option';
        } else {
          buttonText = 'Select ' + data.options[0];
        }
      }
    }
    const gwpVariant = getGwpProduct(data);

    buttonHtml +=
      '<div data-gwp-variant="' +
      gwpVariant +
      '" class="product-cart-button ' +
      buttonContainerClass +
      '" ' +
      outofstock +
      ' ' +
      data_variant +
      '>';
    if (
      (data.options_with_values.length > 1 && data.available) ||
      isKit || isLink
    ) {
      buttonHtml += '<a href="' + buildProductUrlWithNoCollection(data) + '">';
    }
    buttonHtml += '<span class="button-text">' + buttonText + '</span>';
    if (data.available && !isKit && !data.tags.includes('force-oos') && !data.tags.includes('force-sign-up')) {
      buttonHtml += buildPrice_card(data);
    }
    if (
      (data.options_with_values.length > 1 && data.available) ||
      isKit || isLink
    ) {
      buttonHtml += '</a>';
    }
		buttonHtml += '</div>';
	return buttonHtml;
}

	function buildTagBadges(data) {
		return data.tags
		.filter(tag => tag.includes('badge'))
		.map(tag => html`
			<div class="single_badge badge_${tag.split(':')[1] ?? ''}">
				<span></span>
			</div>
		`)
		.join('')
	}

	function buildMetafieldBadges(customBadgeMetafield) {
		try {
			const badgesList = document.querySelector('[data-badges]')?.innerHTML
			const parsedBadgesList = JSON.parse(badgesList ?? '{}')
			const metaobjectIdList = JSON.parse(customBadgeMetafield?.value ?? '[]')

			return metaobjectIdList
				.map(metaobjectFullId => {
					const metaobjectId = metaobjectFullId.split('Metaobject/')[1]
					const badgeMetaobjectData = parsedBadgesList[metaobjectId] ?? null
					if (!badgeMetaobjectData) { return '' }

					const badgeText = badgeMetaobjectData.text ?? ''
					const backgroundColor = badgeMetaobjectData.background_color ?? '#000'
					const textColor = badgeMetaobjectData.text_color ?? '#FFF'
					const badgeImage = badgeMetaobjectData.image ?? ''

					return html`
						<div
							class="single_badge custom_badge ${badgeImage ? 'custom_badge--image' : ''}"
							style="${badgeImage ? '' : `background: ${backgroundColor}; color: ${textColor};`}"
						>
							${badgeImage ? `
								<img src="${badgeImage}" alt="${badgeText}" width="75" height="75"/>
							`:
								`<span>${badgeText}</span>`
							}
						</div>
					`
				})
				.join('')
		} catch (err) {
			console.error(err)
			return ''
		}
	}

	function buildBadges(data){
		const customBadgeMetafield = data?.metafields?.find(metafield => metafield.key === 'badges_list')

		return html`
		<div class="product_badges">
			${(!customBadgeMetafield || !customBadgeMetafield.value) ? buildTagBadges(data) : buildMetafieldBadges(customBadgeMetafield) }
		</div>
	`;
	}

	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		

		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingBottom = 100;
			var productImages = data.original_images && data.original_images.length > 0 ? data.original_images : data.images_info;

			html += '<div class="media media--transparent media--adapt media--hover-effect" style="padding-bottom: '+paddingBottom+'%;"><a href="{{itemUrl}}">';
	
			html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + dataSrcSet + '" ' +
				'height="' + images[0].width + '" ' +
				'width="' + images[0].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';
			let founded_index = 0;
			let next_variant_image_index = 1;
			let featured_media_founded = false;
			let BreakException = {};
           	if (images.length == 1 && data.variants.length == 1) {
           		var index = productImages.findIndex(function(e){return e.src == images[0].src});
           		if (index > -1) {
                   let dataSrcSetAlternative = '';
                   for (var i = 0; i < rangeWidths.length; i++) {
                        if(productImages[index + 1]?.src != 'undefined') {
                          dataSrcSetAlternative += Utils.optimizeImage(productImages[index + 1]?.src, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w'; 
                        }
                        if (i < rangeWidths.length - 1) {
                            dataSrcSetAlternative += ', ';
                        }
                   }
                // Start boost 205603
                var height = productImages[index + 1]?.heigh ? productImages[index + 1].heigh : undefined
                var width = productImages[index + 1]?.width ? productImages[index + 1].width : undefined
                var src = productImages[index + 1]?.src ? Utils.optimizeImage(productImages[index + 1].src, '533x') : undefined
                var alt = productImages[index + 1]?.alt ? productImages[index + 1].alt.replace('~alternative', '') : undefined
                html += '<img class="motion-reduce alternative"' +
                                    'loading="lazy"' +
                                    'srcset="' + dataSrcSetAlternative + '" ' +
                                    'height="' + height + '" ' +
                                    'width="' + width + '" ' +
                                    'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
                                    'src="' + src + '" ' +
                                    'alt="' + alt + '" />';
                // End boost 205603
           		}
           	} else {
           		var currentImageIndex = productImages.findIndex(x => x.src === images[0].src);
                var image = productImages.slice(currentImageIndex + 1).find(img => img.alt && img.alt.includes('~alternative'));
           		if (image) {
				   let dataSrcSetAlternative = '';
                   for (var i = 0; i < rangeWidths.length; i++) {
                     dataSrcSetAlternative += Utils.optimizeImage(image.src, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
                     if (i < rangeWidths.length - 1) {
                     	dataSrcSetAlternative += ', ';
                     }
                   }

                   html += '<img class="motion-reduce alternative"' +
                     'loading="lazy"' +
                     'srcset="' + dataSrcSetAlternative + '" ' +
                     'height="' + image.height + '" ' +
                     'width="' + image.width + '" ' +
                     'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
                     'src="' + Utils.optimizeImage(image.src, '533x') + '" ' +
                     'alt="' + image.alt.replace('~alternative', '') + '" />';
           		} else {
					let dataSrcSetAlternative = '';
                     for (var i = 0; i < rangeWidths.length; i++) {
                       dataSrcSetAlternative += Utils.optimizeImage(images[0]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
                       if (i < rangeWidths.length - 1) {
                       	dataSrcSetAlternative += ', ';
                       }
                     }
                     html += '<img class="motion-reduce alternative"' +
                       'loading="lazy"' +
                       'srcset="' + dataSrcSetAlternative + '" ' +
                       'height="' + images[0].height + '" ' +
                       'width="' + images[0].width + '" ' +
                       'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
                       'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
                       'alt="' + images[0].alt?.replace('~alternative', '') + '" />';           			
           		}
           	}
			
			html += '</a>';
			html += '</div>';
		}
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else {
      html = 'card--outline';
    }
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildDescription(data) {
		let subtitle = data.metafields.find(x => x.key === "product_subtitle")?.value;
		if (subtitle == undefined) return '';
		var html = jQ('<p>' + subtitle + '</p>').text();
		return html;
	}

	function getGwpProduct(data) {
		const gwp_product = data?.metafields?.find(x => x.key === 'gwp_product')?.value;
		return gwp_product?.split(':')[1];
	}

	function buildPrice_card(data) {
		var html = String.raw;
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		const formatMoneyPrice = (price = 0) => Utils.formatMoney(price).replace('.00', '')

		let priceHTML;

		if (priceVaries){
			let price = boostPFSConfig.label.from_price_html.replace('From ', '').replace(/{{ price }}/, formatMoneyPrice(data.price_min)+'-'+formatMoneyPrice(data.price_max))
			if (boostPFSThemeConfig.custom.product_card_use_first_variant) {
				price = formatMoneyPrice(data.variants[0].price).replace('.00', '')
			}
			priceHTML = html`<div class="price__second"><span class="price-item price-item--sale">${price}</span></div>`
		}else if (onSale){
			priceHTML = html`<div class="price__sale"><span class="price-item price-item--sale">${formatMoneyPrice(data.price_min)}</span><span class="price-item price-item--regular">${formatMoneyPrice(data.compare_at_price_min)}</span></div>`;
		}else{
			priceHTML = html`<div class="price__sale"><span class="price-item price-item--sale">${formatMoneyPrice(data.price_min)}</span></div>`;
		}
		return html`<div class="price">
			${priceHTML}
		</div>`;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(data.price_min))
			: Utils.formatMoney(data.price_min);
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
		html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<dl>
						<div class="price__regular">
							<dt>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular">
									${moneyPrice}
						  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<s class="price-item price-item--regular">
								${Utils.formatMoney(data.compare_at_price_min)}
								</s>
						  	</dd>
							<dt>
							  <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							</dt>
							<dd class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}




	// Build Color Swatches
	function eventColorSwatches(event) {
		jQ('.boost-pfs-filter-item-swatch li span').each(function() {
			var img = jQ(this).parents('.boost-pfs-filter-product-item-inner').find('.boost-pfs-filter-product-item-main-image');
			if (event == 'hover') {
				jQ(this).hover(function() {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				});
			}
			if (event == 'click') {
				jQ(this).click(function() {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
                  	jQ(this).closest('.boost-pfs-filter-product-bottom-inner').find('.boost-pfs-filter-product-item-regular-price').html(jQ(this).data('price'));

				});
			}
			jQ(this).focus(function() {
				if (jQ('body').hasClass('boost-pfs-ada')) {
					var newImage = jQ(this).data('img');
					img.attr('srcset', newImage);
				}
			});
		});
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
			html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
		}
		return html;
	}

	function normalizeMetafieldValue(value) {
		if (value == null) {
			return '';
		}

		if (typeof value === 'object') {
			return String(value.value || value.text || '').trim();
		}

		return String(value).trim();
	}

	function getProductPromoCallout(data) {
		var metafields = data.metafields || [];
		var calloutField = metafields.find(function (field) {
			return field.key === 'callout_message' && (!field.namespace || field.namespace === 'promo_callouts');
		});
		var colorField = metafields.find(function (field) {
			return field.key === 'callout_color' && (!field.namespace || field.namespace === 'promo_callouts');
		});

		var message = normalizeMetafieldValue(calloutField && calloutField.value);
		var color = normalizeMetafieldValue(colorField && colorField.value);

		return {
			message: message,
			color: color
		};
	}

	function buildPromoCalloutHtml(message, color, promoClass) {
		var calloutClass = 'card-information__callout';
		if (promoClass) {
			calloutClass += ' ' + promoClass;
		}
		var calloutStyle = color ? ' style="color: ' + color + '"' : '';

		return (
			'<div class="card-information__callout-wrapper">' +
				'<p class="' + calloutClass + '"' + calloutStyle + '>' + message + '</p>' +
			'</div>'
		);
	}

	function isPromoCalloutsEnabled(config) {
		return config.promo_callouts_enabled === true ||
			config.promo_callouts_enabled === 'true' ||
			config.promo_callouts_enabled === 1;
	}

	function productHasSetTag(data) {
		var tags = data.tags;

		if (Array.isArray(tags)) {
			return tags.indexOf('set') !== -1;
		}

		if (typeof tags === 'string') {
			return tags.split(',').map(function (tag) {
				return tag.trim();
			}).indexOf('set') !== -1;
		}

		return false;
	}

	function getCollectionPromoCallout(data, config) {
		var excludedHandles = (config.promo_callout_excluded_collections || 'sets')
			.split(',')
			.map(function (handle) { return handle.trim().toLowerCase(); })
			.filter(Boolean);
		var collectionHandle = (config.collection_handle || '').toLowerCase();

		if (excludedHandles.indexOf(collectionHandle) !== -1) {
			return null;
		}

		if (productHasSetTag(data)) {
			return null;
		}

		var calloutMessage = normalizeMetafieldValue(config.collection_callout_message);
		if (!isPromoCalloutsEnabled(config) || !calloutMessage) {
			return null;
		}

		return {
			message: calloutMessage,
			color: normalizeMetafieldValue(config.collection_callout_color)
		};
	}

	function buildPromoCallout(data) {
		var config = boostPFSThemeConfig.custom || {};
		var collectionCallout = getCollectionPromoCallout(data, config);

		if (collectionCallout && collectionCallout.message) {
			return buildPromoCalloutHtml(
				collectionCallout.message,
				collectionCallout.color,
				''
			);
		}

		var productCallout = getProductPromoCallout(data);
		if (productCallout.message) {
			return buildPromoCalloutHtml(
				productCallout.message,
				productCallout.color,
				productCallout.color ? '' : 'card-information__callout--promo'
			);
		}

		return '';
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = ''
					if(paramSort == k) {
						isSelected = 'selected="selected"'
					}
					sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		jQ('.collection-filters__sort').change(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).val());
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});
	}
    
    Filter.prototype.afterGetFilterData = function(data, eventType, eventInfo) {
		// Check the case when API returns 0 product on first load
		if (data && Array.isArray(data.products)
			&& data.products.length == 0
			&& typeof boostPFSAppConfig.general.collection_product_count != 'undefined'
			&& data.products.length != boostPFSAppConfig.general.collection_product_count) {
			// Check if first load
			if (eventType == 'init' && !Settings.general.productAndVariantAvailable
				&& !Globals.hasFilterOptionParam
				&& typeof FilterApi.beforeCall != 'function'
				&& typeof FilterApi.beforeCallAsync != 'function') {

				this.errorFilterCallback();
				return;
			}
		}
		// Pass check, call setData
		this.setData(data, eventType, eventInfo);
	}
  // Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
		const collectionId = boostPFSAppConfig.general.collection_id;
    const collectionTitle = boostPFSAppConfig.general.collection_title;
		window.trackEvents.viewItemList({
      products: data,
      itemListId: collectionId,
      itemListName: collectionTitle,
      normalizePrice: false,
    });

    this.productItems.forEach(({ $element, data }, index) => {
      const link = $element?.find("a");
      if (!link?.attr("href")?.includes("/products/")) {
        return;
      }
      link.on("click", () => {
        const product = {
          id: data.id,
          title: data.title,
          vendor: data.vendor,
          type: data.product_type,
          variants: data.variants,
        };
        window.trackEvents.selectItem({
          product,
          index,
          itemListId: collectionId,
          itemListName: collectionTitle,
          normalizePrice: false,
        });
      });
    });

		let button_selectors = document.querySelectorAll('.js-open-selectors:not([data-drawer-trigger])');
			if (button_selectors.length > 0){
			for (let i = 0; i < button_selectors.length; i++){
				button_selectors[i].addEventListener('click', function(e){
				e.preventDefault();
				if (this.classList?.contains('disabled') || this.hasAttribute('outofstock')){
					return false;
				}
				this.parentElement.querySelector('.option-selector').style.maxHeight = 'initial';
				this.parentElement.querySelector('.option-selector').style.overflow = 'visible';
				});
			}
		}

		let buttons = document.querySelectorAll('.option-selector label');
		if (buttons.length > 0){
			for (let i = 0; i < buttons.length; i++){
				buttons[i].addEventListener('click', function(e){
					e.preventDefault();
					const gwpVariant = getGwpProduct(data);
					if (this.classList?.contains('disabled') || this.hasAttribute('outofstock')){
						return false;
					}
					let buttons_inner = this.parentElement.querySelectorAll('label');
					for (let j = 0; j < buttons_inner.length; j++){
						buttons_inner[j]?.classList?.remove('active');
					}
					this.classList?.add('active');
					let variant_id = this.dataset.variantId;
					this.parentElement.parentElement.querySelector('.js-open-selectors').setAttribute('data-selected-variant', variant_id);
					if (gwpVariant) {
						this.parentElement.parentElement.querySelector('.js-open-selectors').setAttribute('data-gwp-variant', gwpVariant);
					}

					window.variants_selected = variant_id;
					if (this.parentElement.parentElement.querySelector('.js-open-selectors .price__second span') != null){
						this.parentElement.parentElement.querySelector('.js-open-selectors .price__second span').textContent = this.dataset.variantPrice;
					}
					this.parentElement.parentElement.querySelector('.js-open-selectors .button-text').textContent = 'Add to Bag';
					this.parentElement.parentElement.querySelector('.js-open-selectors').removeEventListener('click', function(){});	
					setAttributes(this.parentElement.parentElement.querySelector('.js-open-selectors'), {
						'data-drawer-trigger': '',
						'aria-controls': 'mini-cart',
						'aria-expanded': 'false'
					});
				});
			}
		}

		let button_selectors_singleV = document.querySelectorAll('.product-cart-button[data-variant-id]');
		for (let i = 0; i < button_selectors_singleV.length; i++){
			button_selectors_singleV[i].addEventListener('click', function(e){
				e.preventDefault();
				let variant_id = this.dataset.variantId;
				let xmlhttp = new XMLHttpRequest();
					xmlhttp.onreadystatechange = function() {
						if (xmlhttp.readyState == XMLHttpRequest.DONE) {   
						if (xmlhttp.status == 400) {
							alert('There was an error 400');
						}
						else {
							alert('something else other than 200 was returned');
						}
						}
					};
				
					xmlhttp.open("POST", "/cart/add", true);
					xmlhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
					xmlhttp.send('id='+variant_id);
			});
		}

		var url = new URL(window.location.href);
		var c = url.searchParams.get("page");
		if (c == null){
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		let li = document.createElement('li');
		if (document.querySelector('.boost-pfs-filter-clear') != null){
			document.querySelector('.boost-pfs-filter-clear').textContent = 'All';
			li.classList.add('boost-pfs-filter-option-item');
			li.classList.add('boost-pfs-filter-option-label');
			li.appendChild(document.querySelector('.boost-pfs-filter-clear'));
		}
		let selected_element = document.querySelector('.boost-pfs-filter-option-label.selected'),
		sort_width;
		if (document.querySelector('.collection-filters__item.sorting') != null){
			sort_width = document.querySelector('.collection-filters__item.sorting').clientWidth;
			document.querySelector('.center_filter').style.width = sort_width+'px';
			document.querySelector('.center_filter').style.display = 'block';
		}
		
		
		if (!selected_element){
			li.classList.add('selected');
		}
		document.querySelector('.boost-pfs-filter-option-item-list')?.prepend(li);
		if (document.querySelector('.boost-pfs-filter-option-title-heading') != null){
			document.querySelector('.boost-pfs-filter-option-title-heading').click();
		}

		if (document.querySelector('.boost-pfs-filter-clear') != null){
			document.querySelector('.boost-pfs-filter-clear').addEventListener('click', function(){
				setTimeout(() => {
					if (document.querySelector('.boost-pfs-filter-option-title-heading') != null && document.querySelector('.boost-pfs-filter-option')?.classList.contains('boost-pfs-filter-option-collapsed')){
						document.querySelector('.boost-pfs-filter-option')?.classList.remove('boost-pfs-filter-option-collapsed');
						document.querySelector('.boost-pfs-filter-option-title-heading').click();
					}
				}, 1000);
			});
		}
		let filter_labels = document.querySelectorAll('.boost-pfs-filter-option-item');
		if (filter_labels.length > 0){
			for (let i = 0; i < filter_labels.length; i++){
				filter_labels[i].addEventListener('click', function(){
					setTimeout(() => {
						document.querySelector('.boost-pfs-filter-option-title-heading').click();
					}, 300);
				});
			}
		}
	};

	/************************** END BUILD TOOLBAR **************************/
})();